module.exports = __webpack_public_path__ + "static/media/video.3555150a.png";